module.exports = __webpack_public_path__ + "static/media/plane(11).28164438.PNG";